module.exports = __webpack_public_path__ + "media/images/common/cart_order_detail_close-78b294a54795da3f47c053ecaa4f6508.png";